import React from "react";
import {
  InputGroup,
  InputStyled,
  SpanStyled,
} from "../../assets/styles/components/Input";

const Input = ({ requiredField, icon = null, onClickIcon = () => {}, ...rest }) => {
  return (
    <InputGroup requiredField={requiredField}>
      <InputStyled {...rest} />
      {icon && <SpanStyled onClick={onClickIcon}>{icon}</SpanStyled>}
    </InputGroup>
  );
};

export default Input;
